import {ClientAgentAffiliationTime} from '../proposal';
import {Dropdown} from './dropdown';

const CLIENT_AGENT_AFFILIATION_TIME_OPTIONS_FR: Dropdown<ClientAgentAffiliationTime>[] = [
  {name: "Depuis moins d'un an", value: ClientAgentAffiliationTime.LESS_THAN_ONE_YEAR},
  {name: 'Entre 1 et 3 ans', value: ClientAgentAffiliationTime.BETWEEN_ONE_AND_THREE_YEARS},
  {name: 'Entre 3 et 5 ans', value: ClientAgentAffiliationTime.BETWEEN_THREE_AND_FIVE_YEARS},
  {name: 'Entre 5 et 10 ans', value: ClientAgentAffiliationTime.BETWEEN_FIVE_AND_TEN_YEARS},
  {name: 'Plus de 10 ans', value: ClientAgentAffiliationTime.MORE_THAN_TEN_YEARS},
];

const CLIENT_AGENT_AFFILIATION_TIME_OPTIONS_EN: Dropdown<ClientAgentAffiliationTime>[] = [
  {name: 'Less than one year', value: ClientAgentAffiliationTime.LESS_THAN_ONE_YEAR},
  {name: 'Between 1 and 3 years', value: ClientAgentAffiliationTime.BETWEEN_ONE_AND_THREE_YEARS},
  {name: 'Between 3 and 5 years', value: ClientAgentAffiliationTime.BETWEEN_THREE_AND_FIVE_YEARS},
  {name: 'Between 5 and 10 years', value: ClientAgentAffiliationTime.BETWEEN_FIVE_AND_TEN_YEARS},
  {name: 'More than 10 years', value: ClientAgentAffiliationTime.MORE_THAN_TEN_YEARS},
];

export const CLIENT_AGENT_AFFILIATION_TIME_OPTIONS = {
  fr: CLIENT_AGENT_AFFILIATION_TIME_OPTIONS_FR,
  en: CLIENT_AGENT_AFFILIATION_TIME_OPTIONS_EN,
};
